import { FC, ReactElement } from 'react';
import confirm, { ModalFuncProps } from './confirm';
import BaseModal, { BaseModalProps } from './base/BaseModal';

export interface StatusModalProps {
  icon?: ReactElement;
  content?: string;
  footer?: ReactElement[];
}

export interface ComponentWithStaticMethod<T> extends FC<T> {
  success: (props?: ModalFuncProps) => void;
  error: (props?: ModalFuncProps) => void;
}

export const Modal: ComponentWithStaticMethod<BaseModalProps> = (
  props: BaseModalProps,
) => {
  return <BaseModal {...props} />;
};

Modal.success = (props?: ModalFuncProps) => {
  confirm({
    title: '保存成功',
    ...props,
    type: 'success',
  });
};
Modal.error = (props?: ModalFuncProps) => {
  confirm({
    title: '保存失败',
    ...props,
    type: 'error',
  });
};
